import React from 'react';
import { Header } from 'semantic-ui-react';

const SectionHeader = props => (
  <Header className="SectionHeader" {...props} as="h3" inverted />
);

export default SectionHeader;
